/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/contacts'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Contacts from '@routes/StaticPages/Contacts';

export const Route = createFileRoute('/contacts')({
  component: () => <CacheDataRoute component={Contacts} path='/contacts' />
});
